<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="userName">
      <Input v-model="form.userName" placeholder="请输入用户名">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="password">
      <Input type="password" v-model="form.password" placeholder="请输入密码">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="webVerifyCode">
      <img :src="getWebVerifyCodeUrl" style="width: 100px; height: 30px; " @click="onWebVerifyCodeClick"/>
      <Input v-model="form.webVerifyCode" placeholder="请输入校验码" style="width: 100px; margin-left: 20px;">
      </Input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form>
</template>
<script>
  import config from '@/config'

  export default {
    name: 'LoginForm',
    props: {
      userNameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '账号不能为空', trigger: 'blur' }
          ]
        }
      },
      passwordRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ]
        }
      },
      webVerifyCodeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '验证码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data () {
      return {
        getWebVerifyCodeUrl:'',
        form: {
          userName: 'super_admin',
          password: '',
          webVerifyCode: ''
        }
      }
    },
    computed: {
      rules () {
        return {
          userName: this.userNameRules,
          password: this.passwordRules,
          webVerifyCode: this.webVerifyCodeRules
        }
      }
    },
    methods: {
      onWebVerifyCodeClick(){
        this.getWebVerifyCodeUrl = (process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro) + '/account/getwebverifycode?r=' + Math.random()
      },
      handleSubmit () {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$emit('on-success-valid', {
              userName: this.form.userName,
              password: this.form.password,
              webVerifyCode: this.form.webVerifyCode
            })
          }
        })
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.getWebVerifyCodeUrl = (process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro) + '/account/getwebverifycode?r=' + Math.random()
      })
    }
  }
</script>
